export default "__VITE_ASSET__DlviTdEf__"